import React,{useState} from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
import { withRouter } from 'react-router';
import { callGET, callPOST, callPUT, callDELETE } from '../../../Utils/ApiUtil';
import * as ShipConstants from '../../../Global/Constants';
import Icons from '../../../Components/Icons/Icons';
import TableRecord from "../../../Components/UI/TableRecord";
import SearchForecast from './SearchForecast';
import EditTerritory from './EditTerritory';
import EditSubTerritory from './EditSubTerritory';
import EditTerritoryUsers from './EditTerritoryUsers';
import ViewForecast from './ViewForecast';


const NewForecast = (props) => {
  const [monthRecord,setMonthRecord] = useState(['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC']);
  const curState = props.curState;
  const territoryList = curState.territoryList;
  const roleList = curState.roleList;
  const forecastData = curState.forecastData;
  const forecastSettingsData = curState.forecastSettings;
  const hasTerritory = forecastSettingsData ? forecastSettingsData.has_territory_enabled : false;
  const editData = curState.editData;
  const tableRecords = curState.tableRecords;
  // console.log(forecastData);
  let mainTerrData = null;
  if(forecastData) {
    if(forecastData.selected_hierarchy) {
      mainTerrData = forecastData.selected_hierarchy;
    }
    /*if(forecastData.hierarchy_forecasts) {
      forecastData.hierarchy_forecasts.map((arr,i) => {
        if(parseInt(arr.parent_id) === 0) {
          mainTerrData = arr;
        }
      })
      if(!mainTerrData) {
        mainTerrData = forecastData.hierarchy_forecasts[0];
      }
    }*/
  }
  let passData = {};
  if(hasTerritory) {
    passData = {territory_hierarchy:territoryList};
  }else {
    passData = {role_hierarchy:roleList};
  }
  // console.log(passData);

  const saveHandler = () => {
    console.log("saveHandler");
  }
  return (
  	<Wrp>
  	  
        <SearchForecast 
          {...props}
        />
       
      <div className="view view-xl">
      {
        curState.isList === true ?
          <div className="view view-xl">
            <div className="card card-transparent mb-0">
              <div className="card-header p-2">
                <div className="card-title">  
                {
                  tableRecords.isAchieved === true ?
                    'Closed Deals - ' + tableRecords.terrName
                  : 
                    'Pipeline Deals - ' + tableRecords.terrName
                }
                <span className="btn btn-border border-default ml-4" onClick={e=>props.getForecast(curState.lastEid,JSON.stringify(passData),curState.lastUid)}>Back</span>
                </div>
              </div>
              <div className="card-body">
                <TableRecord 
                  tableRecords={curState.tableRecords} 
                  recordsChangeHandler={props.getDeals1}
                />
              </div>
            </div>
          </div>
        :
          <ViewForecast
            {...props}
          />
      }
      </div>

      <EditTerritory
        {...props}
        modelOpen = {curState.editTerritoryModel}
        toggleModel = {props.toggleEditTerritory}
        saveHandler = {saveHandler}
      />

      <EditSubTerritory
        {...props}
        modelOpen = {curState.editSubTerritoryModel}
        toggleModel = {props.toggleEditSubTerritory}
        saveHandler = {saveHandler}
      />

      <EditTerritoryUsers
        {...props}
        modelOpen = {curState.editTerritoryUserModel}
        toggleModel = {props.toggleEditTerritoryUser}
        saveHandler = {saveHandler}
      />
  	</Wrp>
  );
}

export default withRouter(NewForecast);  